const languages = new Set([
  'en',
  'de',
  'tr',
  'fr',
  'es',
  'pt',
  'it',
  'ar',
  'hi',
  'ur',
  'ru',
  'ja',
  'zh'
]);
export function storeDownload(locale) {
  const language =
    typeof locale === 'string' ? locale.toLowerCase().split(/[-_]/)[0] : '';
  const code = languages.has(language) ? language : 'en';
  const hl = code === 'zh' ? 'zh-CN' : code;
  return {
    href: `https://play.google.com/store/apps/details?id=com.idmanify.idmanify&hl=${hl}`,
    badge: `/images/stores/google-play-${code === 'zh' ? 'zh-cn' : code}-20261101.png`
  };
}
